import { StoreFeature } from "@omni/types/components/store/storeFeature.type";
import { RequireChildrenFor } from "@omni/types/components/utils/children.types";
import { isDefined } from "@omni/utils/helper.utils";
import { createContext, use } from "react";

type StoreFeaturesContextValue = {
    storeFeatures: Array<StoreFeature>;
};

type StoreFeaturesContextProviderProps = RequireChildrenFor<{
    storeFeatures: Array<StoreFeature>;
}>;

export const StoreFeaturesContext = createContext<
    StoreFeaturesContextValue | undefined
>(undefined);
StoreFeaturesContext.displayName = "StoreFeaturesContext";

export const StoreFeaturesContextProvider = ({
    children,
    storeFeatures
}: StoreFeaturesContextProviderProps) => {
    return (
        <StoreFeaturesContext value={{ storeFeatures }}>
            {children}
        </StoreFeaturesContext>
    );
};

export const useStoreFeaturesContext = () => {
    const context = use<StoreFeaturesContextValue | undefined>(
        StoreFeaturesContext
    );

    if (!isDefined(context)) {
        throw new Error(`${StoreFeaturesContext.displayName} is undefined.`);
    }

    return context;
};
